import { ChangeDetectorRef, Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent {
  //#region Inputs, Outputs, ViewChilds
  //#endregion Inputs, Outputs, ViewChilds

  //#region Public Variables
  public Color: string = 'primary';
  public IsLoading: boolean = false;
  //#endregion Public Variables

  //#region Private Variables
  //#endregion Private Variables

  //#region Properties
  //#endregion Properties

  //#region Constructor and Angular Life Cycle
  constructor(private loadingSpinnerService: LoadingSpinnerService, private cdRef: ChangeDetectorRef, ngxSpinnerService: NgxSpinnerService) {
    this.loadingSpinnerService.IsLoadingObs.subscribe((loading: any) => {
      if (this.IsLoading !== loading) {
        this.IsLoading = loading;

        if (loading) {
          ngxSpinnerService.show();
        } else {
          ngxSpinnerService.hide();
        }

        if (this.cdRef) {
          this.cdRef.detectChanges();
        }
      }
    });
  }
  //#endregion Constructor and Angular Life Cycle

  //#region Event Handlers
  //#endregion Event Handlers

  //#region Public Methods
  //#endregion Public Methods

  //#region Private Methods
  //#endregion Private Methods
}
